export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'ID łącza kanału: ',
    },
    store_id: {
      label: 'Zewnętrzne ID lokalizacji: ',
    },
    store_provisioning_url: {
      label: 'URL aprowizacji sklepu: ',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    error: 'Nie udało się zapisać zmian',
    success: 'Zmiany zostały zapisane',
  },
  instructions: {
    title: 'Instrukcja konfiguracji:',
    step_1:
      'Otwórz stronę <Link>„Lokalizacje"</Link> w Deliverect, rozwiń odpowiednią lokalizację i kliknij przycisk „+ Łącze kanału".',
    step_2: 'Uzupełnij niezbędne informacje. W kroku „Wybierz platformę dostawy online" wybierz „Food Amigos".',
    step_3: 'Ukończ wszystkie kroki. Następnie na stronie „Lokalizacje" kliknij „Edytuj" przy kanale „Food Amigos".',
    step_4: 'Na pasku bocznym kliknij kartę „Połączenie kanału" i wypełnij te dane:',
    step_5: 'Zapisz zmiany, klikając przycisk „Zapisz" w prawym górnym rogu.',
    step_6: 'Po zapisaniu kliknij ikonę „Więcej" w prawym górnym rogu, następnie „Zarejestruj", a potem „Aktywuj".',
    step_7: 'Wróć do karty „Ogólne", zmień „Status integracji" na „Aktywny" i zapisz zmiany.',
    outro: 'Następnie możesz wysłać menu z Deliverect i utworzyć zamówienie testowe.',
  },
  connected: {
    title: 'Deliverect jest połączony',
    description: 'Ta integracja jest skonfigurowana.',
  },
};
